import { Helmet } from "react-helmet";
import {
    Box,
    Switch,
    FormGroup,
    FormControlLabel,
    Divider,
    ListItem,
    Typography,
    Paper
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import { styled } from '@mui/material/styles';
import { DropResult, DragDropContext, Droppable, OnDragEndResponder, Draggable } from 'react-beautiful-dnd';
import Icon from '@mui/material/Icon';
import { ReactComponent as MoveIcon } from "../../../assets/icons/move.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Link as RouterLink, useNavigate } from "react-router-dom";
import SimpleDialog from "../../../components/SimpleDialog";
import ConfirmDialog from "../../../components/ConfirmDialog";
import * as Util from "../../../services/global.service";
import { useSelector, useDispatch } from "react-redux";

const useStyles = makeStyles({
    draggingListItem: {
        background: 'rgb(235,235,235)'
    },
    flexPaper: {
        flex: 1,
        margin: 16,
        minWidth: 350
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    }
});
const styles = {

};

const GoalComponent = ({ item, index, search, link, adjust, onDelete }: DraggableListItemProps) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    useEffect(() => {

    }, []);

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 50,
        height: 24,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));
    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }));
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
    const [itemDel, setItemDel] = React.useState(false);
    const handleConfirmDeleteDialog = (val, serial) => {
        openConfirmDeleteDialog(val);
    };
    const handleConfirmDeleteList = () => {
        /*
        dispatch({
            type: "SET_DELETE_CATEGORY",
            payload: itemDel,
        });
        */

        if (onDelete) onDelete(itemDel)

        openConfirmDeleteDialog(false)
    };

    const handleDeleteClick = React.useCallback((e, data) => {
        e.stopPropagation();
        e.preventDefault();
        setItemDel(data)
        handleConfirmDeleteDialog(true, data)
    }, []);
    return (
        <Draggable draggableId={`${item?.seq}`} index={index}>
            {(provided, snapshot) => (
                <ListItem sx={{ padding: "0", "padding-left": "40px", "padding-right": "40px", "flex-direction": "column" }}
                    ref={provided.innerRef}
                    {...provided.draggableProps}>
                    <Box sx={{ width: "100%", position: "relative", "&:before": { content: '""', position: 'absolute', height: item?.status === "inactive" ? "100%" : "0px", width: item?.status === "inactive" ? "100%" : "0px", top: "0", background: "#FAFAFA", opacity: "0.7" }, }}>
                        <Box
                            sx={{ height: "96px", background: "#FFF", "box-shadow": snapshot.isDragging ? "0 0.375rem 0.875rem 0 rgb(0 0 0 / 13%), 0 0.0625rem 0.25rem 0 rgb(0 0 0 / 11%)" : "", width: "100%", display: "flex", "align-items": "center" }}
                            px="25px"
                        >
                            <Box sx={{ width: "calc(11.84% - 16.665px)" }} pr="15px">
                                <Typography fontSize={16} lineHeight="23.96px" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {item?.seq}.
                                </Typography>
                            </Box>
                            <Box sx={{ width: "calc(11.84% - 16.665px)" }} pr="15px">
                                <Typography fontSize={16} lineHeight="23.96px" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {item?.code}
                                </Typography>
                            </Box>
                            <Box sx={{ width: "calc(30.5% - 16.665px)" }} pr="15px">
                                <Box sx={{ "align-items": "center", display: "flex", "flex-direction": "row" }}>
                                    <Box mr="15px" sx={{ width: "40px", height: "40px", "align-items": "center", display: "flex", "flex-direction": "row", "background-color": item?.color, "border-radius": "3px", "justify-content": "center" }}>
                                        <Icon sx={{ color: "#ffffff", "font-size": "30px" }}>{item?.icon}</Icon>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "column", width: "calc(100% - 55px)" }}>
                                        <Typography pb={item?.options?.name_th !== null && item?.options?.name_th !== undefined && item?.options?.name_th !== "" ? "0" : "5px"} fontWeight="500" fontSize={16} lineHeight="26.91px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                            {item?.options?.name_en !== undefined && item?.options?.name_en !== null ? item?.options?.name_en : item?.name}
                                        </Typography>
                                        {item?.options?.name_th !== null && item?.options?.name_th !== undefined && item?.options?.name_th !== "" ?
                                            <Typography fontWeight="400" fontSize={14} lineHeight="20.93px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                {item?.options?.name_th}
                                            </Typography>
                                            :
                                            null
                                        }
                                    </Box>
                                </Box>
                            </Box>
                            <Box sx={{ width: "calc(11.84% - 16.665px)" }} pr="15px">
                                <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ color: "#5DA196", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {item?.status === 'active' ? "ACTIVE" : "INACTIVE"}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", "flex-direction": "column", width: "calc(17% - 16.665px)" }} pr="15px">
                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {item?.created_by?.fullname !== undefined && item?.created_by?.fullname !== null ? item?.created_by?.fullname : item?.created_at !== undefined && item?.created_at !== null && item?.created_at !== "" ? "Default" : ""}
                                </Typography>
                                <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {Util.dateDayTimeFormatAdmin(item?.created_at)}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", "flex-direction": "column", width: "calc(17% - 16.665px)" }} pr="15px">
                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {item?.updated_by?.fullname !== undefined && item?.updated_by?.fullname !== null ? item?.updated_by?.fullname : item?.updated_at !== undefined && item?.updated_at !== null && item?.updated_at !== "" ? "Default" : ""}
                                </Typography>
                                <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {Util.dateDayTimeFormatAdmin(item?.updated_at)}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", "flex-direction": "row", width: "100px", "z-index": "1" }}>
                                {search !== "" || item?.active === false ?
                                    <Box>
                                        {/* <BootstrapTooltip title={`View my competnecies`} placement="top"> */}
                                        <MoveIcon style={{ opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }} />
                                        {/* </BootstrapTooltip> */}
                                    </Box>
                                    :
                                    <Box {...provided.dragHandleProps}>
                                        <BootstrapTooltip title={`Move`} placement="top">
                                            <MoveIcon />
                                        </BootstrapTooltip>
                                    </Box>
                                }
                                {adjust === false ?
                                    <Box px="20px">
                                        <EditIcon style={{ opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }} />
                                    </Box>
                                    :
                                    <Box px="20px">
                                        <BootstrapTooltip title={`Edit`} placement="top">
                                            <EditIcon style={{ cursor: "pointer" }} onClick={() => { clickLink(link + item.serial) }} />
                                        </BootstrapTooltip>
                                    </Box>
                                }
                                {item?.status === "active" ?
                                    <Box>
                                        <DeleteIcon style={{ opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }} />
                                    </Box>
                                    : item?.is_used && item?.status === "inactive" ?
                                        <Box>
                                            <DeleteIcon style={{ opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }} />
                                        </Box>
                                        :
                                        <Box>
                                            <BootstrapTooltip title={`Delete`} placement="top">
                                                <DeleteIcon style={{ cursor: "pointer" }} onClick={(e) => { handleDeleteClick(e, item.serial) }} />
                                            </BootstrapTooltip>
                                        </Box>
                                }
                            </Box>
                        </Box>
                    </Box>
                    <Divider width="100%" />
                    <SimpleDialog
                        open={isSuccessDeleteDialogOpen}
                        setValue={openSuccessDeleteDialog}
                        text={t(`admin.label.deleteGoalCategory`)}
                    />
                    <ConfirmDialog
                        open={isConfirmDeleteDialogOpen}
                        trash={true}
                        doConfirm={handleConfirmDeleteList}
                        setValue={handleConfirmDeleteDialog}
                        title={t(`admin.label.confirmDeleteGoalCategoryTitle`)}
                        text={t(`admin.label.confirmDeleteGoalCategoryText`)}
                        twoText={true}
                    />
                </ListItem>
            )}
        </Draggable>
    );
};
export default GoalComponent;
